import { render, staticRenderFns } from "./MarketingFeatureLandingView.vue?vue&type=template&id=60cbcf19&scoped=true&"
import script from "./MarketingFeatureLandingView.vue?vue&type=script&lang=js&"
export * from "./MarketingFeatureLandingView.vue?vue&type=script&lang=js&"
import style0 from "./MarketingFeatureLandingView.vue?vue&type=style&index=0&id=60cbcf19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cbcf19",
  null
  
)

export default component.exports